export const environment = {
  name: 'development',
  production: false,
  enableTestFeatures: true,
  firebase: {
    apiKey: "AIzaSyBYz0ax8-oNXo3xEg_KYf_fJ9eZhskVipI",
    authDomain: "brain-evolved-dev.firebaseapp.com",
    databaseURL: "https://brain-evolved-dev.firebaseio.com",
    projectId: "brain-evolved-dev",
    storageBucket: "brain-evolved-dev.appspot.com",
    messagingSenderId: "989222737402",
    appId: "1:989222737402:web:b30b7d0d5b4e4dc51ac043"
  },
  cloudFunctions: {
    region: 'us-central1'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
